import { afterNextRender, Component, DestroyRef, inject, Renderer2 } from '@angular/core';
import { RouterOutlet, RouterLink, Router, NavigationEnd } from '@angular/router';
import { HeaderComponent } from "./layout/header/header.component";
import { SidebarComponent } from "./layout/sidebar/sidebar.component";
import { FooterComponent } from './layout/footer/footer.component';
import { BackdropComponent } from '@components/shared/backdrop/backdrop.component';
import { CartSidebarComponent } from '@components/shared/cart/cart-sidebar/cart-sidebar.component';
import { ScriptService } from './services/script.service';
import { IubendaService } from './services/gdpr/iubenda.service';
import { AppConfigService, Log } from '@core/services/config/app-config.service';
import { DOCUMENT } from '@angular/common';
import { BannerPromoService } from './services/banner-promo/banner-promo.service';
import { filter } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, RouterLink, HeaderComponent, SidebarComponent, FooterComponent, BackdropComponent, CartSidebarComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
    private renderer       = inject(Renderer2);
    private scriptService  = inject(ScriptService);
    private iubendaService = inject(IubendaService);
    private document       = inject(DOCUMENT);
    private appConfig      = inject(AppConfigService);
    protected readonly bannerService = inject(BannerPromoService);
    private router = inject(Router);
    private iubenda = inject(IubendaService);
    private destroyRef = inject(DestroyRef);


    title = 'app.emporio-elettrico.it';


    constructor() {

        afterNextRender(() => {

            // this.iubenda.injectPopUpPrivacyScript();

            document.body.classList.add('hydrated');
            if(document.querySelector('app-root')) {
                // (document.querySelector('app-root') as HTMLElement)?.style.setProperty('display', 'block');
                document.documentElement.classList.add('client-ready');

            }

            this.injectIubendaCons();


            let scriptGTM = this.renderer.createElement('script');
            scriptGTM.async = true;
            scriptGTM.text = "window.dataLayer = window.dataLayer || [];function gtag() {dataLayer.push(arguments);}gtag('consent', 'default',{'ad_storage': 'denied','analytics_storage': 'denied', 'ad_user_data': 'denied', 'ad_personalization': 'denied' ,'wait_for_update': 2000});gtag('set', 'url_passthrough', true);gtag('set', 'ads_data_redaction', true);(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src= 'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f); })(window,document,'script','dataLayer','" + this.appConfig.getGlobalGTM() + "');";
            this.renderer.appendChild(this.document.head, scriptGTM);

            let scriptFBQ = this.renderer.createElement('script');
            scriptFBQ.async = true;
            scriptFBQ.text = "!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version=2.0;n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');"
            this.renderer.appendChild(this.document.body, scriptFBQ);


            // init di facebook
            // this.tagService.tag.facebook.init();

            let scriptBING = this.renderer.createElement('script');
            scriptBING.async = true;
            scriptBING.text = "(function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[] ,f=function(){var o={ti:'148016248'};o.q=w[u],w[u]=new UET(o),w[u].push('pageLoad')},n=d.createElement(t),n.src=r,n.async=1,n.onload=n .onreadystatechange=function() {var s=this.readyState;s &&s!=='loaded'&& s!=='complete'||(f(),n.onload=n.onreadystatechange=null)},i= d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)})(window,document,'script','//bat.bing.com/bat.js','uetq');"
            this.renderer.appendChild(this.document.body, scriptBING);

        });
    }
    
    private injectIubendaCons(): void {
        var consScript = this.scriptService.loadJsScript(
            this.renderer,
            `var _iub = _iub || {}; _iub.cons_instructions = _iub.cons_instructions || []; _iub.cons_instructions.push(["init", {api_key: "cXApqq1MOEJcLXtdajM7hml940oYYSYj"}]);`,
            'text/javascript',
            'head',
            '',
            [],
            true
        );

        var iub = this.scriptService.loadJsScript(
            this.renderer,
            'https://cdn.iubenda.com/cons/iubenda_cons.js',
            'text/javascript',
            'head'
        );

        iub.onload = () => {
            this.iubendaService.inject();
        };

    }
}